import React from 'react';

const MarineAnimations = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {/* Subtle floating bubbles */}
      <div className="absolute top-20 left-10 w-2 h-2 bg-jade-300/20 rounded-full animate-bubble-float"></div>
      <div className="absolute top-32 left-1/4 w-1.5 h-1.5 bg-ocean-300/25 rounded-full animate-bubble-float-delayed"></div>
      <div className="absolute top-48 right-1/4 w-3 h-3 bg-jade-200/15 rounded-full animate-bubble-float-slow"></div>
      <div className="absolute top-64 right-16 w-1 h-1 bg-ocean-200/30 rounded-full animate-bubble-float"></div>
      
      <div className="absolute bottom-40 left-8 w-2.5 h-2.5 bg-jade-300/20 rounded-full animate-bubble-float-delayed"></div>
      <div className="absolute bottom-56 left-1/3 w-1.5 h-1.5 bg-ocean-300/25 rounded-full animate-bubble-float-slow"></div>
      <div className="absolute bottom-72 right-1/3 w-2 h-2 bg-jade-200/18 rounded-full animate-bubble-float"></div>
      <div className="absolute bottom-88 right-20 w-1 h-1 bg-ocean-200/30 rounded-full animate-bubble-float-delayed"></div>
      
      {/* Gentle current waves */}
      <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-jade-300/10 to-transparent animate-tidal-flow"></div>
      <div className="absolute top-2/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-ocean-300/10 to-transparent animate-tidal-flow" style={{animationDelay: '2s'}}></div>
      
      {/* Subtle ripple effects */}
      <div className="absolute top-1/4 right-1/4">
        <div className="w-8 h-8 border border-jade-300/10 rounded-full animate-ripple"></div>
      </div>
      <div className="absolute bottom-1/4 left-1/4" style={{animationDelay: '3s'}}>
        <div className="w-6 h-6 border border-ocean-300/10 rounded-full animate-ripple"></div>
      </div>
      
      {/* Floating kelp-like elements */}
      <div className="absolute bottom-0 left-12 w-1 h-20 bg-gradient-to-t from-seagreen-300/20 to-transparent rounded-t-full animate-gentle-sway"></div>
      <div className="absolute bottom-0 right-24 w-0.5 h-16 bg-gradient-to-t from-jade-300/25 to-transparent rounded-t-full animate-gentle-sway" style={{animationDelay: '1s'}}></div>
      <div className="absolute bottom-0 left-1/3 w-0.5 h-12 bg-gradient-to-t from-ocean-300/20 to-transparent rounded-t-full animate-gentle-sway" style={{animationDelay: '2s'}}></div>
    </div>
  );
};

export default MarineAnimations;
